import { ActionTree } from "vuex";
import { IPagination, RootState } from "@/types";
import {
  IMember,
  IMemberListRequest,
  IMemberCreateRequest,
  IMemberUpdateRequest,
  MemberState,
} from "@/types/member";
import CustomRequest from "../customRequest";

const actions: ActionTree<MemberState, RootState> = {
  async adminGetList({ commit }, params: IMemberListRequest) {
    await CustomRequest.get<IPagination<IMember>>({
      uri: "/sales/member",
      params,
      commit,
      target: "pagination",
    });
  },

  async adminGet({ commit }, memberId: number) {
    await CustomRequest.get<IMember>({
      uri: `/sales/member/${memberId}`,
      commit,
      target: "single",
    });
  },

  async adminUpdate(
    { commit },
    datas: { member_id: number; params: IMemberUpdateRequest }
  ) {
    const { error } = await CustomRequest.patch<IMember>({
      uri: `/sales/member/${datas.member_id}`,
      params: datas.params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async adminCreate({ commit }, params: IMemberCreateRequest) {
    const { error } = await CustomRequest.post<IMember>({
      uri: `/sales/member/`,
      params,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async adminDelete({ commit }, member_id: number) {
    const { error } = await CustomRequest.delete({
      uri: `/sales/member/${member_id}`,
      flash: true,
    });

    return !error;
  },

  async flipRecruiting({ commit }, member_id: number) {
    const { error } = await CustomRequest.patch<IMember>({
      uri: `/sales/member/${member_id}/recruiting`,
      commit,
      target: "single",
      flash: true,
    });

    return !error;
  },

  async isUniqueId({ commit }, login_id: number) {
    const { data } = await CustomRequest.get<boolean>({
      uri: `user/is-unique-id/${login_id}`,
    });

    return !!data;
  },

  async isUniqueEmail({ commit }, email: string) {
    const { data } = await CustomRequest.get<boolean>({
      uri: `sales/member/is_unique_email/${email}`,
    });
    return !!data;
  },
};

export default actions;
